import {
  Container,
  Typography,
  Button,
  Box,
  Paper,
  Stack,
  IconButton,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

const QuestionComponents = ({
  questions = [],
  answers = [],
  files = [],
  editMode = [],
  handleEditToggle,
  handleChange,
  handleFileChange,
  handleDelete,
  handleFileInputClick,
}) => {
  return (
    <Container maxWidth="md" className="pb-8">
      <div>
        <p className="font-Poppins font-medium text-black">
          Rules and informations in regard with Subjective Question
        </p>
        <ul className="text-sm leading-8 text-black font-medium">
          <li>
            Click the Pencil Icon to start writing your answer and save icon to
            save the answer
          </li>
          <li>
            Question with (*) is compulsory question and the doer must answer
            that question
          </li>
          <li className="font-bold ">
            The total size of all uploaded files must not exceed 60 KB.
          </li>
          <li>
            You can write answer of any one from the 2nd and 3rd question or
            both.
          </li>
          <li>Once you submit the answer you cannot edit or undo the test.</li>
          <li>
            While uploading the supporing document name the files as per
            question. For Eg. question01_file.pdf/docx/docs
          </li>
        </ul>
      </div>
      <Paper
        elevation={3}
        style={{ padding: "15px 15px" }}
        className="outline-none"
      >
        {questions &&
          questions.map((question, index) => (
            <Box key={index} mb={4}>
              <Stack flexDirection="row" gap={1} justifyContent="space-between">
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    textAlign: "justify",
                  }}
                  variant="h6"
                  component="h2"
                  gutterBottom
                >
                  Q{index + 1}. {question}
                  {index === 0 ? (
                    <span className="ml-2 text-xs italic">
                      required<strong className="text-red-700">(*)</strong>
                    </span>
                  ) : (
                    ""
                  )}
                </Typography>
                <IconButton
                  sx={{
                    alignSelf: "self-start",
                  }}
                  onClick={() => handleEditToggle(index)}
                >
                  {editMode[index] ? <SaveIcon /> : <EditIcon />}
                </IconButton>
              </Stack>
              <textarea
                rows={7}
                value={answers[index]}
                onChange={(e) => handleChange(index, e.target.value)}
                readOnly={!editMode[index]}
                className="w-full border-[2px] rounded-md font-Poppins px-3 py-2 font-Poppins font-medium text-sm outline-none"
                style={{
                  fontFamily: "Poppins",
                  backgroundColor: editMode[index] ? "white" : "#f0f0f0",
                }}
              />
              <Box>
                <div>
                  <i style={{ fontFamily: "Poppins" }}>
                    To support your answer you can attach up to 3 documents
                  </i>
                  <span
                    onClick={() => {
                      const input = document.getElementById(
                        `file-upload-${index}`
                      );
                      handleFileInputClick();
                      input.click();
                    }}
                    style={{ fontFamily: "Poppins" }}
                    className="ml-2 cursor-pointer underline underline-offset-2 font-medium text-sm font-Poppins text-blue-900"
                  >
                    Upload Files
                  </span>
                  <input
                    id={`file-upload-${index}`}
                    type="file"
                    multiple
                    hidden
                    onChange={(e) => handleFileChange(index, e)}
                  />
                </div>
                <Stack
                  flexDirection={{
                    xl: "row",
                    sm: "row",
                    xs: "column",
                  }}
                  alignItems={{
                    xl: "center",
                    sm: "center",
                    xs: "start",
                  }}
                  gap={1}
                >
                  {files[index] &&
                    files[index].map((file, fileIndex) => (
                      <Stack
                        flexDirection="row"
                        alignItems="center"
                        gap={1}
                        key={fileIndex}
                      >
                        <Chip
                          label={file.name}
                          variant="outlined"
                          onDelete={() => handleDelete(index, fileIndex)}
                        />
                      </Stack>
                    ))}
                </Stack>
              </Box>
            </Box>
          ))}
      </Paper>
    </Container>
  );
};

export default QuestionComponents;
